import styled from 'styled-components';
import { colors } from '../../static/theme';

const HeaderWrapper = styled.div`
  display: inline-flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 100px;
  padding: 30px 0;
  position: relative;
  .top_garage {
    margin-bottom: 10px;
    width: 183px;
    height: 98px
  }
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    background-color: ${colors.blue};
    bottom: 0;
    height: 17px;
  }

  img {
    max-height: 100px;
    max-width: 350px;;
  }
`;

export default HeaderWrapper;
